import { render, staticRenderFns } from "./Budget.vue?vue&type=template&id=d21f961e&scoped=true"
import script from "./Budget.vue?vue&type=script&lang=js"
export * from "./Budget.vue?vue&type=script&lang=js"
import style0 from "./Budget.vue?vue&type=style&index=0&id=d21f961e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21f961e",
  null
  
)

export default component.exports